/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestdeclinedtoast2Inputs */

const en_requestdeclinedtoast2 = /** @type {(inputs: Requestdeclinedtoast2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request declined`)
};

const de_requestdeclinedtoast2 = /** @type {(inputs: Requestdeclinedtoast2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfrage abgelehnt`)
};

/**
* | output |
* | --- |
* | "Request declined" |
*
* @param {Requestdeclinedtoast2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestdeclinedtoast2 = /** @type {((inputs?: Requestdeclinedtoast2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestdeclinedtoast2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestdeclinedtoast2(inputs)
	return de_requestdeclinedtoast2(inputs)
});
export { requestdeclinedtoast2 as "requestDeclinedToast" }